import { theme } from '@factorialco/deprecated-design-system'
import { CompanyEventCalendarEventFragment } from 'generated/resources/graphql'

import { CalendarEventNormalizer } from 'modules/core/components/CalendarEventList/types'
import {
  dateBackendDateTimeToUITime,
  dateBackendDateTimeToUITimeRange,
  formatBackendDateRange,
  stringToDate,
} from 'modules/core/lib/dates'

export const companyEventCalendarEventNormalizer: CalendarEventNormalizer<
  CompanyEventCalendarEventFragment
> = (item) => {
  const startOn = stringToDate(item.startsAt, 'backend_datetime')
  const endOn = item.endsAt ? stringToDate(item.endsAt, 'backend_datetime') : undefined

  let description = ''
  if (endOn) {
    description = (
      startOn.isSame(endOn, 'day') ? dateBackendDateTimeToUITimeRange : formatBackendDateRange
    )(item.startsAt, item.endsAt)
  } else {
    description = dateBackendDateTimeToUITime(item.startsAt)
  }

  const title = item.title ?? ''

  return {
    title,
    color: theme.colors.radicalRed1200,
    description,
    ...(endOn && !endOn.isSame(startOn, 'day')
      ? {
          fromDate: startOn.toDate(),
          toDate: endOn.toDate(),
        }
      : {
          toDate: startOn.toDate(),
        }),
    isPending: false,
  }
}
